// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"230":"d1e10a61","232":"ea26b47d","310":"57fdd7c1","831":"f8defde8","940":"b6f7008b","992":"70357516"}[chunkId] + ".css";
};